import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step2" }
const _hoisted_2 = { class: "donar-info" }
const _hoisted_3 = ["placeholder", "disabled"]
const _hoisted_4 = ["placeholder", "disabled"]
const _hoisted_5 = ["placeholder", "readonly", "disabled"]
const _hoisted_6 = ["placeholder", "disabled"]
const _hoisted_7 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Personal Info", -1 /* HOISTED */)),
      _createElementVNode("form", null, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('first_name'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.billing_fields.first_name) = $event)),
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_3), [
          [_vModelText, $setup.store.billing_fields.first_name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('last_name'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.store.billing_fields.last_name) = $event)),
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_4), [
          [_vModelText, $setup.store.billing_fields.last_name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: $setup.trans('email'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.billing_fields.email) = $event)),
          readonly: $props.is_logged_in && $props.email,
          disabled: $setup.store.loading,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_vModelText, $setup.store.billing_fields.email]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          placeholder: $setup.trans('phone'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.store.billing_fields.phone) = $event)),
          disabled: $setup.store.loading,
          onkeyup: "this.value=this.value.replace(/[^\\d]/,'')"
        }, null, 8 /* PROPS */, _hoisted_6), [
          [_vModelText, $setup.store.billing_fields.phone]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: $setup.trans('address'),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.store.billing_fields.address) = $event)),
          disabled: $setup.store.loading
        }, null, 8 /* PROPS */, _hoisted_7), [
          [_vModelText, $setup.store.billing_fields.address]
        ])
      ])
    ])
  ]))
}